<template>
<div id="app">
    <div class="rate" v-for="item in rateData">
      <div class="rate-title">{{item.title}}：</div>
      <div class="rate-item">
        <div class="item1" v-for="(val, i) in item.initStar" @click="slelectStar(i, item)">
           <img class="auto-img" v-if="item.count - 1 >= i" src="../../../assets/img/score.png">
           <img class="auto-img" v-if="!(item.count - 1 >= i)" src="../../../assets/img/score4.png">
        </div>
      </div>
      <div class="count">{{item.count}}星</div>
    </div>

    <div class="center">
      <p style="color: #0f1325">您可以在这里留下宝贵的建议，我们将持续改善服务质量</p>
      <div class="center-1">
        <el-input
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 20 }"
            placeholder="请输入您宝贵的建议"
            v-model="evaluationContent"
            resize="none"
            maxlength="500"
            show-word-limit
        >
        </el-input>
      </div>
    </div>
  <div style="margin-top: 3px;">
  <Button type="info" @click="evaluateSubmit">保存 </Button>
  </div>
</div>
</template>
<script>

export default {
  props: {
    workId: {
      type: String,
      value: "",
    },
  },
  data(){
    return{
      evaluationContent:"",
      attitude:5,
      //商品评价的数据
      rateData: [
        {
          title: '服务评价',
          initStar: 10,
          count: 10
        },
      ]
    }
  },
  methods: {
    async evaluateSubmit(){
      let q = {}
      q.workId = this.workId
      q.attitude = this.attitude
      q.speed = this.speed
      q.quality = this.quality
      q.evaluationContent = this.evaluationContent
      let res = await $utils.api.load("/customer/customer/evaluation",q,"post")
      if (res && res.code == 200) {
        $utils.toast.success("保存成功");
        $utils.url.go(0);
        this.$Modal.remove();
      }
    },
    //选择星星
    slelectStar(index, item) {
      item.count = index + 1;
      if (item.title == '服务评价'){
        this.attitude = item.count
      }
      if (item.title == '响应速度'){
        this.speed = item.count
      }
      if (item.title == '维修质量'){
        this.quality = item.count
      }
    }
  },
}
</script>
<style scoped>


  .rate{
    display: flex;

  }

  .rate-title{
    font-weight: bold;
    margin-top: 3px;
    color: #0f1325;
  }

  .rate-item{
    margin: 0 15px;
  }

  .rate-item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .item1{
    width: 24px;
    height: 24px;

    margin: 0px 10px;
  }

  .count{
    font-weight: bold;
    margin-top: 3px;
    color: #0f1325;
  }

  .auto-img{
    width: 100%;
    display: block;
  }
</style>
